export default "__VITE_ASSET__CWcF0SE5__"